import React, { useState, useEffect, useRef } from 'react';
import "../../assets/css/dashboard.css";
import "../../assets/css/global.css";
import hamburger from '../../assets/images/hamburger.png';
import SearchBox from '../SearchBox';
import DataNotFound from '../DataNotFound';
import { useDispatch } from "react-redux";
import { listVins } from "../../redux/actions/vinsAction"
import { vinsAPI, vinsCountApi, plantData, vinAgingListing, getAreaZone } from "../../utils/apiServices"
import { NavLink, useNavigate } from 'react-router-dom';
import { initMapCluster } from '../../constants/MapContainer';
import { allVINsFilter, allDispatchFilter, vinHeader, plantHeader, APILimit, path_Operation } from '../../constants/constVariables'
import Filter from '../Filter';
import HeaderCard from '../HeaderCard';
import { Button } from '@mui/material';
import { getPlantValue, postUsageAnalyticsCall } from '../../constants/Utils';
import SmallCardDashboard from '../SmallCardDashboard';
import BackButton from '../../clientComponents/BackButton/BackButton';
import Loader from '../Loader';
import { AutoSizer, CellMeasurerCache, List } from 'react-virtualized';
import { useLocation } from 'react-router-dom'
import { useAuthorizationContext } from '../../providers/AuthorizationHandler/AuthorizationHandler';

export default function Dashboard_Home() {

    const cache = useRef(
        new CellMeasurerCache({
            fixedHeight: true,
            defaultHeight: 92,
        })
    )

    const [filteredVin, setFilteredVin] = useState([]);
    const [areaZone, setAreaZone] = useState([]);
    const [cardVin, setCardVin] = useState([]);
    const [cardAgingVin, setCardAging] = useState([]);
    const [vins, setvins] = useState([]);
    const [currentSearch, setcurrentSearch] = useState("all");
    const [currentFilter, setcurrentFilter] = useState("all");
    const [headerCardData, setHeaderCardData] = useState([])
    const [mapVINs, setMapVINs] = useState([])
    const [areaSort, setAreaSort] = useState([])
    const [plants, setPlants] = useState([])
    const [listAllVmstatus, setStatus] = useState("plant");
    // const [aggingVin, setaggingVinStatus] = useState(false);
    const [loader, setLoader] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pageLeaveTime, setPageLeaveTime] = useState();
    const filterRef = useRef(0); // for filter div
    const viewAllRef = useRef([]);
    const form = useRef(null);
    const Map = useRef(null);
    const filterPlantName = getPlantValue();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { user } = useAuthorizationContext();

    const fetchPlants = async () => {
        const response = await plantData(filterPlantName.value);
        if (filterPlantName.value == "cv_all" || filterPlantName.value == 'pv_all') {
            setPlants(response?.data?.data)
        }
        else {
            setPlants([response.data.data])
        }
    };
    const fetchVins = async (vin) => {
        if (vin) {
            const response = await vinsAPI(filterPlantName.value, APILimit, 0, "all", "all");
            setvins(response.data.data);
            setCardVin(response.data.data);
            setFilteredVin(response.data.data);
            dispatch(listVins(response.data.data));
        }
        else {
            const response = await vinAgingListing(filterPlantName.value, APILimit, 0, "all", currentSearch);
            setvins(response.data.data);
            setCardAging(response.data.data);
            setFilteredVin(response.data.data);
            dispatch(listVins(response.data.data));
        }
        fetchareaZone();
        setLoader(true);
    };
    const fetchareaZone = async () => {
        if (areaZone.length < 1) {
            const area = await getAreaZone(filterPlantName.value)
            setAreaZone(area?.data?.data);
        }
    }
    const fetchVinsCount = async () => {
        const response = await vinsCountApi(filterPlantName.value);
        setHeaderCardData([
            {
                header: "Vehicle",
                click: true,
                data: [
                    {
                        header: "All",
                        value: response?.data?.data?.all
                    },
                    {
                        header: "Parked",
                        value: response?.data?.data?.parked
                    },
                    {
                        header: "Non Parked",
                        value: response?.data?.data?.nonparked
                    }
                ],
            },
            {
                header: "Aging of Vehicle",
                click: true,
                data: [
                    {
                        header: "0 - 30 Days",
                        value: response?.data?.data?.days
                    },
                    {
                        header: "31 - 60 Days",
                        value: response?.data?.data?.one_months
                    },
                    {
                        header: "61 - 90 Days",
                        value: response?.data?.data?.two_months
                    },
                    {
                        header: "Above 90 Days",
                        value: response?.data?.data?.three_months
                    }
                ]
            },
            {
                header: "Invoiced Vehicle (Last 30 Days)",
                click: true,
                data: [
                    {
                        header: "All",
                        value: response?.data?.data?.dispatch_count
                    },
                    {
                        header: "Billed",
                        value: response?.data?.data?.dispatched_non_parked
                    },
                    {
                        header: "Billed but not Dispatched",
                        value: response?.data?.data?.dispatched_parked
                    }
                ],
            }
        ])
    };

    useEffect(() => {
        fetchVins(true);
        setPageLeaveTime(new Date())
    }, []);
    useEffect(() => { fetchPlants(); }, []);
    useEffect(() => { fetchVinsCount(); }, []);
    useEffect(() => {
        setLoader(true);
    }, [headerCardData, plants]);

    useEffect(() => {
        if (Map.current) {
            const up = [];
            vins.filter((data, i) => data?.vehicle_parking_status && data?.coordinates ? up.push({ ...data?.coordinates[0], vin_number: data['vin_number'] }) : null)
            initMapCluster(up, null, false, areaZone?.area_data, areaZone?.zone_data, setAreaSort);
        }
    }, [Map.current, areaZone])
    useEffect(() => {
        if (Map.current) {
            const up = [];
            cardAgingVin.filter((data, i) => data?.vehicle_parking_status && data?.coordinates ? up.push({ ...data?.coordinates[0], vin_number: data['vin_number'] }) : null)
            initMapCluster(up, null, false, areaZone?.area_data, areaZone?.zone_data, setAreaSort);
        }
    }, [cardAgingVin])

    useEffect(() => {
        if (areaSort.domain === "area") {
            setvins(cardVin.filter((d, i) => {
                return d.area_fk__area_name === areaSort.name
            }))
        }
        else if (areaSort.domain === "zone") {
            setvins(cardVin.filter((d, i) => {
                return d.zone_fk__zone_name === areaSort.name
            }))
        }
        else {
            setvins(cardVin)
        }
    }, [areaSort])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])


    function switchTOVinsTable(pos) {
        setLoader(false);

        if (form.current != null) {
            form.current.value = "";
            setcurrentSearch("all");
        }
        if (filterRef.current) {
            filterRef.current.style.display = "none"
            for (var i = 0; i < filterRef?.current?.childNodes?.length; i++) {
                filterRef.current.childNodes[i].childNodes[0].checked = false;
            }
        }
        if (pos === 0) {

            setStatus("vinDetails");
            if (cardVin.length > 0) {
                setFilteredVin(cardVin);
                setvins(cardVin);
                setLoader(true);
            }
            else {
                setLoader(false);
            }

            viewAllRef.current.style.display = "block";
        }
        else if (pos === 2) {
            navigate("/dispatched");
        }
        else {
            // console.log("dfdfd")
            setLoader(false);
            setStatus("vinAging");
            setcurrentFilter("all");
            if (cardAgingVin.length === 0) {
                fetchVins(false);
                // console.log("inside if")
            }
            else {
                setvins(cardAgingVin);
                setFilteredVin(cardAgingVin);
                // console.log("inside else")
                setLoader(true);
            }
            viewAllRef.current.style.display = "block";

        }
    }

    const handleSearch = (value) => {

        if (listAllVmstatus !== "vinDetails") {
            // console.log("Inside age")
            const searchList = filteredVin.filter((item) => {
                return item.vin_number.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            setvins(searchList);
        }
        else {
            const searchList = filteredVin.filter((item) => {
                return item.vin_number.toLowerCase().indexOf(value.toLowerCase()) !== -1;
            });
            setvins(searchList);
        }


    }


    const handleFilterValue = async (value) => {
        if (listAllVmstatus != "vinDetails") {
            setLoading(false)
            setcurrentFilter(value)
            const response = await vinAgingListing(filterPlantName.value, APILimit, 0, value, currentSearch);
            setLoading(true)
            if (response?.data?.data) {
                setvins(response.data.data);
                setFilteredVin(response.data.data)
            }
        }
        else {
            setLoading(false)
            setcurrentFilter(value)
            const response = await vinsAPI(filterPlantName.value, APILimit, 0, value, currentSearch,);
            setLoading(true)
            if (response.data.data) {
                setvins(response.data.data);
                setFilteredVin(response.data.data)
            }
        }
    }
    const browserBack = () => {
        navigate("/");
    }
    const noRowsRenderer = () => { return <div>No rows</div> }
    const rowRenderer = ({ index, isScrolling, isVisible, key, parent, style, }) => {
        return (
            <>
                <div style={style}>
                    <SmallCardDashboard link={"/dashboard/vin-details"} data={vins[index]} key={index} header={vins[index]?.vin_number} subheader={vinHeader} secondHeader={vins[index]?.vc_number} table_name={"vin-details"} />
                </div>
            </>
        );
    };
    return (
        <>

            {
                loader ?
                    <>
                        <div className='breadcrumb'>
                            <BackButton action={"dashboard"} handleClick={browserBack} />
                        </div>
                        <HeaderCard clickFunction={switchTOVinsTable} data={headerCardData} />
                        <div className='dashboard-map-container'>
                            <div className='dashboard-map' id="map_container" ref={Map}></div>
                            <div className='dashboard-vehicle'>
                                <div className='dashboard-vehicle-header largerFont'>
                                    {
                                        listAllVmstatus != "plant" ?
                                            <>
                                                <div className='dashboard-vin-tab'>
                                                    <span style={{ marginRight: "1rem", whiteSpace: "nowrap" }}>Vehicle</span>
                                                    <div className='dashboard-vin-count mediumFont'>{vins.length}</div>
                                                </div>
                                                <div style={{ display: "flex", alignItems: "center", position: "relative", gap: '0.5rem' }}>
                                                    <SearchBox handleSearch={handleSearch} inputSearchPlaceholder={"VINs..."} formRef={form} />
                                                    {listAllVmstatus !== "vinDetails" ?
                                                        <Filter handleFilterValue={handleFilterValue} header={allDispatchFilter} filterRef={filterRef} />
                                                        :
                                                        <Filter handleFilterValue={handleFilterValue} header={allVINsFilter} filterRef={filterRef} />
                                                    }
                                                </div>
                                            </> :
                                            <span style={{ whiteSpace: "nowrap" }}>{filterPlantName.value === "all" ? "All Plants" : "Plant"}</span>
                                    }

                                </div>
                                <div className='small-card-inner'>
                                    {
                                        loading ?
                                            listAllVmstatus !== "plant" ?
                                                vins.length === 0 ?
                                                    <DataNotFound /> :
                                                    vins.length > 0 ?

                                                        <AutoSizer>
                                                            {({ width: windowWidth, height: windowHeight }) => {
                                                                const width = windowWidth;
                                                                const height = windowHeight;
                                                                const rowHeight = 92;

                                                                return (
                                                                    <div>
                                                                        <List
                                                                            // ref={vListRef}
                                                                            width={width}
                                                                            height={height}
                                                                            rowCount={vins?.length}
                                                                            rowHeight={rowHeight}
                                                                            rowRenderer={rowRenderer}
                                                                            containerStyle={{ display: "flex", flexDirection: "column", gap: "10px", padding: "5px" }}
                                                                            // containerStyle={{ overflow: "initial" }}
                                                                            overscanRowCount={3}
                                                                            noRowsRenderer={noRowsRenderer}
                                                                        />
                                                                    </div>
                                                                );
                                                            }}
                                                        </AutoSizer>
                                                        : null
                                                :
                                                plants?.length === 0 ?
                                                    <DataNotFound /> :
                                                    plants?.map((plant, index) => {
                                                        return (
                                                            index < 5 ?
                                                                <SmallCardDashboard data={plant} key={index} table_name={"plant-details"} header={plant.name} subheader={plantHeader} /> : null
                                                        )
                                                    })
                                            :
                                            <div className='loader' style={{ position: "absolute", top: "0", left: "0", background: "#fff", zIndex: "999" }}>
                                                <Loader />
                                            </div>
                                    }
                                </div>
                                <NavLink to={"/dashboard/all-VINs"} exact>
                                    <Button variant="primary" className='small-card-button regularFont' ref={viewAllRef}>View All</Button>
                                </NavLink>
                            </div>
                        </div>
                        <NavLink to={"/dashboard/all-VINs"} exact><img className='dashboard-floating-allVINs' src={hamburger} alt="hamburger" /></NavLink>
                    </>
                    :
                    <>
                        <div className='loader'>
                            <Loader />
                        </div>
                    </>
            }
            <style jsx="true">
                {`
                    .dashboard-tabs:focus-within{
                        border: 1px solid #BDBBF4;
                        box-shadow: 0px 0px 10px rgba(0, 0, 39, 0.2);
                    }
                   
                    .small-card-button{                                    
                        letter-spacing: 1.25px;                       
                        text-transform: uppercase;
                        background: #82C1A7;
                        box-shadow: 0px 3px 3px rgba(0, 0, 67, 0.13);
                        border-radius: 6px;
                        font-family: 'Open Sans';
                        font-style: normal;
                        font-weight: 600;                        
                        line-height: 18px;
                        text-align: center;
                        color: #FFFFFF;
                        padding: 0.5rem 1rem;
                        border: none;
                        cursor: pointer;
                        margin: 0.5rem 0.5rem 0;
                        float: right;
                        display: none;
                                                
                    }
                    .small-card-button:hover{
                        background: #488f71;
                    }
                    .small-card-inner{
                        overflow: hidden scroll;
                        flex-grow: 1;
                        height: 2rem;
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding: 10px 10px 10px 0;
                        position: unset !important;
                    }
                    @media only screen and (max-width: 768px){
                        .dashboard-main {
                            height: calc(100% - 84px);
                        }
                    }
                    @media only screen and (max-width: 1440px){        
                          
                        .small-card-button{                                    
                            font-size: 12px;                         
                        } 
                        // .small-card-container{
                        //     margin: 0.5rem 0.15rem;
                        // }           
                    }
                    .dashboard-vehicle:has(.vehicle-header-util) .small-card-button {
                        display: block;
                    }
                `}
            </style>
        </>
    )
}
